import { createIcon } from '@chakra-ui/icons';

export const Comment = createIcon({
  displayName: 'Comment',
  viewBox: '0 0 15 13',
  path: [
    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.93603 0.762665H12.496C13.1443 0.762665 13.6694 1.28773 13.6694 1.936V8.38933C13.6694 9.0376 13.1443 9.56267 12.496 9.56267H7.9155C7.84213 9.56267 7.7706 9.58559 7.7109 9.62823L4.25263 12.0984C4.01965 12.2648 3.69603 12.0983 3.69603 11.812V9.91467C3.69603 9.72026 3.53843 9.56267 3.34403 9.56267H1.93603C1.28776 9.56267 0.762695 9.0376 0.762695 8.38933V1.936C0.762695 1.28773 1.28776 0.762665 1.93603 0.762665Z"
        stroke="currentColor"
        strokeWidth="1.52533"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
